<template>
  <section class="page">
    <h2 class="page__title">{{ $t('chpo.brief.title') }}</h2>

    <p v-if="loading">{{ $t('chpo.brief.loading') }}</p>
    <p v-else-if="error" style="color:#D81717">{{ $t('chpo.brief.errorPrefix') }}: {{ error }}</p>

    <div class="page__editor" v-if="!loading">
      <div class="page__editor-inner">
        <textarea
          v-model="text"
          class="brief-textarea"
          :placeholder="$t('chpo.brief.textareaPh')"
        />
        <div class="page__editor-actions">
          <ActionButton :color="'#2A8A1B'" :disabled="saving" :text="$t('nav.save')" @click="onSave" />
        </div>
      </div>
    </div>

    <div class="page__footer">
      <ViewNavButtons
        class="page__footer-nav"
        :prev-text="$t('nav.back')"
        :next-text="$t('nav.next')"
        :prev-to="{ path: '/chpo/forces' }"
        :next-to="{ path: '/chpo/plan' }"
      />
    </div>
  </section>
</template>

<script>
import ViewNavButtons from '@/components/navigation/ViewNavButtons.vue'
import ActionButton from '@/components/widgets/ActionButton.vue'
import { getChpoConclusionFromContext, updateChpoConclusion } from '@/api/chpoConclusions'
import { http, getRefresh, setAccess } from '@/api/http'

export default {
  name: 'BriefView',
  components: { ViewNavButtons, ActionButton },
  data() {
    return {
      text: '',
      loading: false,
      saving: false,
      error: null,
      conclusionId: null,
    }
  },
  async mounted() {
    await this.loadConclusion()
  },
  methods: {
    async loadConclusion() {
      this.loading = true; this.error = null
      try {
        const concl = await getChpoConclusionFromContext()
        if (concl && concl.id) {
          this.conclusionId = concl.id
          this.text = concl.text || ''
        } else {
          this.conclusionId = null
          this.text = ''
        }
      } catch (e) {
        this.error = e?.message || String(e)
      } finally {
        this.loading = false
      }
    },
    async onSave() {
      if (!this.conclusionId) {
        return
      }
      this.saving = true; this.error = null
      try {
        await updateChpoConclusion(this.conclusionId, { text: String(this.text || '') })
      } catch (e) {
        const is401 = (e && (e.status === 401 || /unauthor/i.test(e?.message || '') || /unauthor/i.test(e?.payload?.detail || '')))
        if (is401) {
          try {
            const refresh = getRefresh()
            if (refresh) {
              const r = await http.post('users/token/refresh/', { refresh })
              const newAccess = r?.data?.access
              if (newAccess) setAccess(newAccess)
              await updateChpoConclusion(this.conclusionId, { text: String(this.text || '') })
              this.saving = false
              return
            }
          } catch (_) { /* провал рефреша */ }
        }
        this.error = e?.message || String(e)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.page__title {
  margin: 0;
  color: #111827;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
}
.page__editor {
  border-radius: 16px;
  overflow: hidden;
}
.page__editor-inner {
  background: #FFFFFF;
  border-radius: 16px;
  outline: 1px #F1F2F4 solid;
  outline-offset: -1px;
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.brief-textarea {
  width: 100%;
  min-height: 280px;
  resize: vertical;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  padding: 12px;
  outline: none;
  color: #111827;
  font-size: 20px;
  line-height: 24px;
  font-family: 'Times New Roman', Times, serif;
}
.brief-textarea::placeholder {
  color: #A0AEC0;
}
.page__editor-actions {
  display: flex;
  justify-content: flex-end;
}
.page__footer {
  display: flex;
  justify-content: flex-end;
}
</style>
